module.exports = __webpack_public_path__ + "static/media/Barbados.fe5fb721.png";